import React from "react";

export const ApointmentNewCard = ({ v, i }) => {
  //   const formatteMonth = ;
  //   const formatteDay = ;
  const formatteyear = Intl.DateTimeFormat("en-US", {
    year: "numeric",
  }).format(v?.scheduledDatenew);
  const formatteWeekDay = Intl.DateTimeFormat("en-US", {
    weekday: "long",
  }).format(v?.scheduledDatenew);

  return (
    <div class="cards">
      <div className="first-box">
        <p className="appointment-value">
          <span className="appointement-key">Customer Name</span>
          {v?.withName || "name"}
        </p>
        <p className="appointment-value">
          {" "}
          <span className="appointement-key">Contact Person</span>
          {v?.name || "no contactPerson"}
        </p>
        <p className="appointment-value">
          <span className="appointement-key">Contact Number</span>
          {v?.phoneNumber || "no name"}
        </p>
      </div>
      <div className="date-box">
        {/* <div className="date">
          <div className="date-box1">
            <p>{formatteWeekDay.slice(0, 3)}</p>
            <h2>
              {Intl.DateTimeFormat("en-US", {
                day: "numeric",
              }).format(v?.scheduledDatenew)}
            </h2>
          </div>
          <div className="date-box2">
            <p>
              {Intl.DateTimeFormat("en-US", {
                month: "long",
              })
                .format(v?.scheduledDatenew)
                .slice(0, 3)}
            </p>

            <p>{formatteyear}</p>
          </div>
        </div>

        <div className="time">
          <h2>Time</h2>
          <p>{v?.time}</p>
        </div> */}

        <div>
          <h2 style={{fontSize:"18px"}}>Date</h2>
          <p style={{fontSize:'14px'}}>{v?.scheduledDate}</p>
        </div>
        <div>
          <h2 style={{fontSize:"18px"}} >Time</h2>
          <p style={{fontSize:'14px'}}>{v?.time}</p>
        </div>
      </div>
    </div>
  );
};
